import { logout, setCredentials, setUser } from "../slices/authSlice";
import { apiService } from "./apiService";

// Auth endpoints
export const authApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: "/auth/login",
        method: "POST",
        data: credentials,
      }),
      invalidatesTags: ['User'],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setCredentials(data));
        } catch (error) {
          // Login failed - error จะถูกจัดการใน baseQuery แล้ว
        }
      },
    }),

    refreshToken: builder.mutation({
      query: (refreshToken) => ({
        url: "/auth/refresh",
        method: "POST",
        data: { refreshToken },
      }),
    }),
    getCurrentUser: builder.mutation({
       query: () => ({
        url: "/auth/decode",
        method: "POST",
      }),
      providesTags: ['User'],
      // Transform response and save to Redux
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          
          // Save user data to Redux state
          dispatch(setUser(data));
        } catch (error) {
          console.error(error);
          
          // Handle error if needed
          if (error.error?.status === 401) {
            dispatch(logout());
          }
        }
      },
    }),

    logout: builder.mutation({
      query: () => ({
        url: "/auth/logout",
        method: "POST",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(logout());
        } catch (error) {
          // Force logout even if API call fails
          dispatch(logout());
        }
      },
    }),
  }),
});

// Tickets endpoints
export const ticketsApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    getTickets: builder.query({
      query: (params) => ({
        url: "/tickets",
        params,
      }),
      providesTags: ["Ticket"],
      // จัดการ error เฉพาะสำหรับ endpoint นี้
      transformErrorResponse: (response) => {
        if (response.status === 404) {
          return { message: "ไม่พบรายการ Ticket" };
        }
        return response.data;
      },
    }),

    getTicketById: builder.query({
      query: (id) => ({
        url: `/tickets/${id}`,
      }),
      providesTags: (result, error, id) => [{ type: "Ticket", id }],
    }),

    createTicket: builder.mutation({
      query: (newTicket) => ({
        url: "/tickets",
        method: "POST",
        data: newTicket,
      }),
      invalidatesTags: ["Ticket"],
      // จัดการหลังสร้าง ticket สำเร็จ
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          // แสดง success message
          if (typeof window !== "undefined" && window.toast) {
            window.toast.success("สร้าง Ticket สำเร็จ");
          }
        } catch (error) {
          // Error จะถูกแสดงใน baseQuery แล้ว
        }
      },
    }),

    updateTicket: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `/tickets/${id}`,
        method: "PUT",
        data: patch,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "Ticket", id }],
      // Optimistic update
      async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          ticketsApi.util.updateQueryData("getTicketById", id, (draft) => {
            Object.assign(draft, patch);
          })
        );

        try {
          await queryFulfilled;
          if (typeof window !== "undefined" && window.toast) {
            window.toast.success("อัพเดท Ticket สำเร็จ");
          }
        } catch {
          // Revert optimistic update on error
          patchResult.undo();
        }
      },
    }),
  }),
});

// Export hooks
export const { useLoginMutation, useRefreshTokenMutation, useLogoutMutation,useGetCurrentUserMutation } =
  authApi;

export const {
  useGetTicketsQuery,
  useGetTicketByIdQuery,
  useCreateTicketMutation,
  useUpdateTicketMutation,
} = ticketsApi;
